module.exports = __webpack_public_path__ + "static/media/dollar.59015fdc.png";